import { ACTIONS, COLUMN_TYPE, CONTA_CORRENTE_VALUES_DEFAULT } from "../../../../utils/financialHelper";
import FormContasCorrentesCrud from "./FormContasCorrentesCrud";
import useCrud from "../../../../hooks/useCrud";
import { useFinancialContext } from "../../../../context/Financial/FinancialContext";
import CrudTablePage from "../../../../components/Financial/CrudTablePage";

const ContasCorrentesCrud = () => {
  const headCells = [
    { key: 'banco', field: 'banco', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Banco' },
    { key: 'agencia', field: 'agencia', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Agência' },
    { key: 'conta', field: 'conta', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Conta' },
    { key: 'descricao', field: 'descricao', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Descricao' },
    { key: 'actions', field: 'actions', type: COLUMN_TYPE.BUTTONS, alignRight: true, label: 'Ações' },
  ];

  const funcionalidade = 'Conta Corrente'

  const { bancos } = useFinancialContext();

  const handleAdditionalValues = (values) => {
    const bankName = bancos.find((b) => b.varId === values.bankCode)?.value;
    const newValues = { ...values, banco: bankName };
    return newValues;
  };

  const {
    action,
    buttonLabel,
    dadoFoiModificado,
    filterValue,
    isLoading,
    isLoadingSubmit,
    items: contasCorrentes,
    open,
    title,
    values,
    setAction,
    setButtonLabel,
    setDadoFoiModificado,
    setFilterValue,
    setItems: setContasCorrentes,
    setValues,
    handleClose,
    handleDelete,
    handleEdit,
    handleOpen,
    handleSubmit,
    handleView,
  } = useCrud(
    '/bank-accounts',
    CONTA_CORRENTE_VALUES_DEFAULT,
    funcionalidade,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    handleAdditionalValues,
  );

  return (
    <CrudTablePage
      isLoading={isLoading}
      funcionalidade={funcionalidade}
      rows={contasCorrentes}
      setRows={setContasCorrentes}
      headCells={headCells}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      filterValue={filterValue}
      setFilterValue={setFilterValue}
      dadoFoiModificado={dadoFoiModificado}
      setDadoFoiModificado={setDadoFoiModificado}
      open={open}
      title={title}
      buttonLabel={buttonLabel}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      action={action}
      handleOpen={handleOpen}
    >
      <FormContasCorrentesCrud
        values={values}
        setValues={setValues}
        isDelete={action === ACTIONS.DELETE}
        isLoadingSubmit={isLoadingSubmit}
      />
    </CrudTablePage>
  )
};

export default ContasCorrentesCrud;